<template>
  <div>
    <label class="dark-text fs-small font-weight-bold"
      ><span class="primary--text">*</span> تاریخ</label
    >
    <span id="theDate">
      <v-text-field
        outlined
        dense
        class="mt-2"
        v-model="newItem.dateCont"
        prepend-inner-icon="mdi-calendar-month"
      ></v-text-field>
    </span>
    <date-picker
      element="theDate"
      v-model="newItem.dateCont"
      color="#bf0000"
    ></date-picker>

    <label class="dark-text fs-small font-weight-bold"
      ><span class="primary--text">*</span> نوع کار</label
    >
    <v-select
      outlined
      dense
      class="mt-2"
      v-model="newItem.activityCont"
      :items="pieDetails.projects"
    ></v-select>

    <label class="dark-text fs-small font-weight-bold">توضیحات</label>
    <v-textarea
      outlined
      dense
      class="mt-2"
      rows="3"
      v-model="newItem.description"
    ></v-textarea>

    <label class="dark-text fs-small font-weight-bold"
      ><span class="primary--text">*</span> مقدار هزینه‌‌شده</label
    >
    <vuetify-money
      v-model="newItem.amount"
      :valueWhenIsEmpty="whenIsEmpty"
      :options="vMoneyOptions"
      type="number"
      outlined
      dense
      class="mt-2"
    />

    <label class="dark-text fs-small font-weight-bold"
      >مقدار بازپرداخت‌‌شده (اختیاری)
      <br />
      <span class="primary--text fs-xxsmall"
        >موجودی صندوق:
        <b>{{ Number(pieDetails.totalWell).toLocaleString() }} ریال</b></span
      >
    </label>
    <vuetify-money
      v-model="newItem.receiveCont"
      :valueWhenIsEmpty="whenIsEmpty"
      :options="vMoneyOptions"
      type="number"
      outlined
      dense
      class="mt-2"
    />
    <div
      v-if="computedAmount"
      class="red--text font-weight-bold fs-xsmall"
      style="transform: translateY(-15px)"
    >
      مبلغ وارد‌‌شده از موجودی صندوق بیشتر می‌باشد!
    </div>

    <p class="primary--text font-weight-bold">
      <v-icon class="primary--text">mdi-alert-circle-outline</v-icon>
      تعیین دوره زمانی در این نسخه بی تاثیر خواهد بود.
    </p>

    <label class="dark-text fs-small font-weight-bold"
      ><span class="primary--text">*</span> تکرار مشارکت</label
    >
    <v-radio-group
      v-model="newItem.repeatCont"
      style="transform: translateX(18px)"
      row
      class="mt-3"
      @change="setRepeatTime"
    >
      <v-radio
        v-for="(item, index) in repeatOptions"
        :key="index"
        :label="item.text"
        :value="item.value"
      ></v-radio>
    </v-radio-group>

    <div v-if="newItem.repeatCont != 'off'">
      <label class="dark-text fs-small font-weight-bold"
        ><span class="primary--text">*</span> تاریخ شروع تکرار</label
      >
      <span id="theDate2">
        <v-text-field
          outlined
          dense
          class="mt-2"
          v-model="newItem.repeatDate"
          prepend-inner-icon="mdi-calendar-month"
        ></v-text-field>
      </span>
      <date-picker
        element="theDate2"
        v-model="newItem.repeatDate"
        color="#bf0000"
        @change="reactivity = !reactivity"
      ></date-picker>
      <span v-show="false">{{ reactivity }}</span>
    </div>
    <div class="d-flex">
      <label class="dark-text fs-small font-weight-bold"
        >قطعات محاسبه‌‌شده:</label
      >
      <span class="ms-2 primary--text font-weight-bold">{{
        Number(computedSlice).toLocaleString()
      }}</span>
    </div>
    <p class="primary--text font-weight-bold" v-if="computedSlice < 0">
      <v-icon class="primary--text">mdi-alert-circle-outline</v-icon>
      مقدار محاسبه‌‌شده منفی می‌باشد.
    </p>

    <div class="d-flex flex-sm-row flex-column justify-space-between mt-4">
      <v-btn
        width="150"
        class="primary white--text mx-sm-0 mx-auto mb-sm-0 mb-4"
        @click="submit()"
        :loading="busy"
        :disabled="computedAmount || computedSlice < 0"
        ><v-icon small class="me-1">mdi-check</v-icon> ثبت مشارکت</v-btn
      >
      <v-btn
        width="150"
        @click="$emit('closeDialog')"
        class="primary white--text mx-sm-0 mx-auto"
        ><v-icon small class="me-1">mdi-close</v-icon> لغو</v-btn
      >
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: ["userId", "pieUserId", "pieDetails", "refresh"],
  data() {
    return {
      moment: moment,
      restriction: "",
      ownerId: null,
      reactivity: false,
      newItem: {
        dateCont: moment(new Date()).format("jYYYY/jMM/jDD"),
        repeatCont: "off",
        amount: 0,
        receiveCont: 0,
        activityCont: "",
        description: "",
      },
      repeatOptions: [
        {
          text: "بدون تکرار",
          value: "off",
        },
        {
          text: "روزانه",
          value: "daily",
        },
        {
          text: "هفتگی",
          value: "weekly",
        },
        {
          text: "هر دو هفته یکبار",
          value: "biweekly",
        },
        {
          text: "ماهانه",
          value: "monthly",
        },
        {
          text: "سالانه",
          value: "annually",
        },
      ],
      busy: false,
    };
  },
  methods: {
    setRepeatTime() {
      if (this.newItem.repeatCont == "daily") {
        this.newItem.repeatDate = moment(new Date())
          .add(1, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.newItem.repeatCont == "weekly") {
        this.newItem.repeatDate = moment(new Date())
          .add(7, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.newItem.repeatCont == "biweekly") {
        this.newItem.repeatDate = moment(new Date())
          .add(14, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.newItem.repeatCont == "monthly") {
        this.newItem.repeatDate = moment(new Date())
          .add(30, "days")
          .format("jYYYY/jMM/jDD");
      } else if (this.newItem.repeatCont == "annually") {
        this.newItem.repeatDate = moment(new Date())
          .add(365, "days")
          .format("jYYYY/jMM/jDD");
      }
    },
    submit() {
      this.busy = true;
      let url =
        this.restriction == "requireApproval"
          ? "/contribution/expense/newpending/"
          : "/contribution/expense/new/";
      this.$http
        .post(
          this.baseUrl + "/" + this.role + url + this.$route.params.id,
          {
            dateCont: this.newItem.dateCont,
            activityCont: this.newItem.activityCont,
            amount: Number(this.newItem.amount),
            receiveCont: Number(this.newItem.receiveCont),
            repeatCont: this.newItem.repeatCont,
            userId: this.userId,
            pieUserId: this.pieUserId,
            description: this.newItem.description,
            managerId: this.role == "manager" ? this.ownerId : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newItem = {
              dateCont: moment(new Date()).format("jYYYY/jMM/jDD"),
              repeatCont: "off",
              amount: 0,
              receiveCont: 0,
              activityCont: "",
              description: "",
            };
            this.busy = false;
            this.$emit("closeDialog");
            this.$emit("closeMain");
            this.$emit("getInfo");
          } else {
            this.toast(res.data, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
  },
  computed: {
    computedAmount() {
      if (
        Number(this.newItem.receiveCont) > Number(this.pieDetails.totalWell)
      ) {
        return true;
      } else return false;
    },
    computedSlice() {
      return (
        this.pieDetails.valCashMultiplier *
        (this.newItem.amount - this.newItem.receiveCont)
      );
    },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.restriction = localStorage.getItem("restriction");
    this.ownerId = localStorage.getItem("ownerId");
    this.newItem = {
      dateCont: moment(new Date()).format("jYYYY/jMM/jDD"),
      repeatCont: "off",
      amount: 0,
      receiveCont: 0,
      activityCont: "",
      description: "",
    };
  },
  watch: {
    refresh() {
      this.newItem = {
        dateCont: moment(new Date()).format("jYYYY/jMM/jDD"),
        repeatCont: "off",
        amount: 0,
        receiveCont: 0,
        activityCont: "",
        description: "",
      };
    },
  },
};
</script>
